import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import DataTable from '../../../../../Common/DataTable';
import ComponentDeleteModal from '../../../../../Common/DeleteModal/ComponentDeleteModal';
import { RootState } from '../../../../../redux/rootState';
// import { setLoader } from '../../../../../redux/loaderSlice';
import EndPoints from '../../../../../Routes/EndPoints';
import { deleteBidStart, getAssociatedBidsStart, resetJobStarterState } from '../redux/addJobSlice';
import { bidsColumns } from '../utils/constants';
import { formatBidListingData } from '../utils/helper';
import { BidsData } from '../utils/types';
import ReOrderBidsModal from '../../../../ComponentNavBar/ReOrderBidsModal';

export default function ComponentBid() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [showDeleteModal, setDeleteModal] = useState(false);
  const { jobId: addJobId, bidList, totalBids } = useSelector((state: RootState) => state.jobStarterReducer);
  const [selectedId, setSelectedId] = useState('');
  const [openReorderModal, setOpenReorderModal] = useState(false);
  const { jobId } = useParams();

  const dispatch = useDispatch();

  const handleButtonClick = () => {
    navigate(`${EndPoints.ADD_JOB_BID}/${jobId || addJobId}`);
    dispatch(resetJobStarterState());
  };

  const handleData = () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      jobId: jobId || addJobId,
    };
    dispatch(getAssociatedBidsStart(payload));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  useEffect(() => {
    if (String(jobId) || addJobId) {
      handleData();
    }
  }, [jobId, addJobId]);

  const handleDelete = (id: string) => {
    setDeleteModal(true);
    setSelectedId(id);
  };

  const handleDeleteModal = () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      jobId: jobId || addJobId,
      bidid: selectedId,
    };
    dispatch(deleteBidStart(payload));
    setDeleteModal(false);
  };

  const handleEdit = (id: string) => {
    navigate(`${EndPoints.BID_WORKSHEET}/${id}`);
    dispatch(resetJobStarterState());
  };

  const generateBid = () => {
    navigate(`/${EndPoints.BID_PDF_SCREEN}/${jobId || addJobId}`);
  };

  return (
    <>
      <DataTable<BidsData>
        handleButtonClick={handleButtonClick}
        data={formatBidListingData(bidList)}
        columns={bidsColumns}
        totalRecords={totalBids}
        buttonText="Add Bid"
        searchButton="Generate Bid"
        searchButtonDisable={bidList?.length === 0}
        handleSearchButtonClick={generateBid}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleData={handleData}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        buttonNameFifth={bidList?.length > 1 ? 'Re-order list' : ''}
        handleButtonClickFifth={() => setOpenReorderModal(true)}
        manualPageSize
        manualPageSizeValue={200}
        handleDataFromComponent
      />

      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setDeleteModal(false)}
        handleDelete={handleDeleteModal}
      />
      {openReorderModal && (
      <ReOrderBidsModal
        open={openReorderModal}
        handleClose={() => setOpenReorderModal(false)}
        handleData={handleData}
      />
      )}
    </>
  );
}
